type OrganizationKeys = 'organization' | 'all-organizations';

export const ORGANIZATION_KEY = {
  ORGANIZATION: 'organization' as OrganizationKeys,
  ALL_ORGANIZATIONS: 'all-organizations' as OrganizationKeys,
};
